export class CreditCheck {
FirstName: string;
LastName: string;
Address1: string;
Address2: string;
City: string;
State: string;
ZipCode: string;
IDNumber: string;
IDType: string;
}